var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useEffect, useState } from "react";
import { useOkapiKy } from "@folio/stripes/core";
import { fetchCurrentUser } from "../api/userService";
import { RoleEnum } from "../types/RoleEnum";
export var useActiveRoles = function () {
    var okapiKy = useOkapiKy();
    var _a = useState(function () {
        var storedRoles = sessionStorage.getItem("activeRoles");
        var storedOrg = sessionStorage.getItem("activeOrganization");
        var hasRoles = storedRoles && storedRoles !== "undefined";
        var hasOrg = storedOrg && storedOrg !== "undefined";
        if (hasRoles && hasOrg) {
            return JSON.parse(storedRoles);
        }
        return undefined;
    }), roles = _a[0], setRoles = _a[1];
    var _b = useState(function () {
        var stored = sessionStorage.getItem("activeOrganization");
        return stored && stored !== "undefined" ? JSON.parse(stored) : undefined;
    }), activeOrganization = _b[0], setActiveOrganization = _b[1];
    var _c = useState(function () {
        var storedRoles = sessionStorage.getItem("activeRoles");
        var storedOrg = sessionStorage.getItem("activeOrganization");
        var hasRoles = storedRoles && storedRoles !== "undefined";
        var hasOrg = storedOrg && storedOrg !== "undefined";
        return !(hasRoles && hasOrg);
    }), isLoading = _c[0], setIsLoading = _c[1];
    var _d = useState(false), isFetching = _d[0], setIsFetching = _d[1];
    useEffect(function () {
        var fetchActiveRoles = function () { return __awaiter(void 0, void 0, void 0, function () {
            var activeRoles, storedOrg, fetchedUser, userRoles, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        activeRoles = sessionStorage.getItem("activeRoles");
                        storedOrg = sessionStorage.getItem("activeOrganization");
                        if (activeRoles && activeRoles !== "undefined" && storedOrg && storedOrg !== "undefined") {
                            setRoles(JSON.parse(activeRoles));
                            setActiveOrganization(JSON.parse(storedOrg));
                            setIsLoading(false);
                            return [2 /*return*/];
                        }
                        if (isFetching) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        setIsFetching(true);
                        setIsLoading(true);
                        return [4 /*yield*/, fetchCurrentUser(okapiKy)];
                    case 2:
                        fetchedUser = _a.sent();
                        userRoles = (fetchedUser === null || fetchedUser === void 0 ? void 0 : fetchedUser.activeRoles) || [];
                        sessionStorage.setItem("activeRoles", JSON.stringify(userRoles));
                        setRoles(userRoles);
                        if (fetchedUser === null || fetchedUser === void 0 ? void 0 : fetchedUser.activeOrganization) {
                            sessionStorage.setItem("activeOrganization", JSON.stringify(fetchedUser.activeOrganization));
                            setActiveOrganization(fetchedUser.activeOrganization);
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.error("useActiveRoles - Error fetching user:", error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        setIsFetching(false);
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        }); };
        if (okapiKy && typeof okapiKy === "function" && !roles) {
            fetchActiveRoles();
        }
        else if (roles) {
            setIsLoading(false);
        }
    }, [okapiKy, roles, isFetching]);
    return { roles: roles, activeOrganization: activeOrganization, isLoading: isLoading };
};
var isSuperuser = function (activeRoles) {
    return activeRoles && activeRoles.includes(RoleEnum.SUPERUSER);
};
export var hasRole = function (activeRoles, requiredRole) {
    if (isSuperuser(activeRoles))
        return true;
    if (requiredRole === "None") {
        return true;
    }
    return activeRoles && activeRoles.includes(requiredRole);
};
export var hasAtLeastOneRole = function (activeRoles, requiredRole) {
    for (var _i = 0, requiredRole_1 = requiredRole; _i < requiredRole_1.length; _i++) {
        var role = requiredRole_1[_i];
        if (hasRole(activeRoles, role)) {
            return true;
        }
    }
    return false;
};
export var hasAtLeastOneRoleAndDontHaveOther = function (activeRoles, requiredRole, notRequiredRole) {
    return (hasAtLeastOneRole(activeRoles, requiredRole) &&
        !hasRole(activeRoles, notRequiredRole));
};
export var hasExactlyRoles = function (activeRoles, exactRoles) {
    var normalizedRole = function (role) {
        return String(role !== null && role !== void 0 ? role : "")
            .trim()
            .toUpperCase();
    };
    var activeRole = (activeRoles !== null && activeRoles !== void 0 ? activeRoles : []).map(normalizedRole);
    var exactRole = (exactRoles !== null && exactRoles !== void 0 ? exactRoles : []).map(normalizedRole);
    if (activeRole.length !== exactRole.length)
        return false;
    return activeRole.every(function (role) { return exactRole.includes(role); });
};
